const detectIfMobileBrowser = () => {
  const userAgent = navigator.userAgent;
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i;

  return mobileRegex.test(userAgent);
};

export default detectIfMobileBrowser;
